@if (registration) {
  <div class="registration-supplementary-equipment">
    <sc-flex fitHeight>
      <div class="options-list">
        <sc-flex vertical stretchContent>
          @if (cps.isPropertyTrue('visitoverview.register.messagingLanguage', false)) {
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.messagingLanguage"></sc-dictionary-label>
              </mat-label>
              <mat-select name="messagingLanguage" [(ngModel)]="registration.transport.messaging.messagingLanguage"
                #messagingLanguageType="ngModel" [required]="true">
                @for (o of getMessagingLanguagesOrdererByCurrentTranslation(); track o) {
                  <mat-option
                    value="{{o}}">
                    <sc-dictionary-label dictionaryKey="common.enum.language.{{o}}"></sc-dictionary-label>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <div class="form-checkbox">
            <div class="checkbox-label">
              <mat-checkbox class="col first" name="useGlobalConnect" [(ngModel)]="registration.transport.messaging.useGlobalConnect"
                #useGlobalConnect="ngModel">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.useGlobalConnect"></sc-dictionary-label>
              </mat-checkbox>
            </div>
          </div>
          <div class="form-checkbox">
            <div class="checkbox-label">
              @if (yardPropertiesService.isSmsEnabled()) {
                <mat-checkbox class="col first" name="useSms" [(ngModel)]="registration.transport.messaging.useSms"
                  #useGlobalConnect="ngModel">
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.useSms"></sc-dictionary-label>
                </mat-checkbox>
              }
            </div>
          </div>
        </sc-flex>
      </div>
      <sc-content-spacer></sc-content-spacer>
      @if ((registration.registerNow || (registration.transport.timing.planningType !== planningType.IN_ADVANCE && registration.transport.timing.planningType !== planningType.TIMEFRAME)) && !yardPropertiesService.isHideInRegisterTransportEnabled()) {
        <div class="options-list no-field-space"
          >
          <sc-flex vertical stretchContent>
            @if (yardPropertiesService.isShowNoHandoutEnabled()) {
              <div class="form-checkbox no-supplementary-cbx"
                >
                <div class="checkbox-label">
                  <mat-checkbox [(ngModel)]="registration.noSupplementaryEquipmentHandout"
                    [ngModelOptions]="{standalone: true}" [disabled]="isNoSupplementaryEquipmentHandoutDisabled()">
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.supplementaryEquipment.nosupplementaryequipmenthandout"></sc-dictionary-label>
                  </mat-checkbox>
                </div>
              </div>
            }
            <sc-content-spacer vertical></sc-content-spacer>
            @for (se of registration.supplementaryEquipments; track se) {
              <div>
                <sc-flex >
                  <div class="checkbox-label">
                    <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}" [disabled]="isNoSupplementaryEquipmentHandoutSelected()">
                      {{ se.name }}
                    </mat-checkbox>
                  </div>
                  @if (se.availableIdentifiers?.length > 0) {
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field class="checkbox-value" appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-common.equipment.entity.equipment.identifier"></sc-dictionary-label></mat-label>
                        <mat-select name="identity" [(ngModel)]="se.selectedIdentifier" [ngModelOptions]="{standalone: true}" [disabled]="se.selected === false" required="true">
                          @for (identity of se.availableIdentifiers; track identity) {
                            <mat-option [value]="identity">{{identity}}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </sc-flex>
                  <sc-content-spacer vertical></sc-content-spacer>
                </div>
              }
            </sc-flex>
          </div>
        }
      </sc-flex>
    </div>
  }
